import { render, staticRenderFns } from "./walletList.vue?vue&type=template&id=6d10c84e&scoped=true&"
import script from "./walletList.vue?vue&type=script&lang=js&"
export * from "./walletList.vue?vue&type=script&lang=js&"
import style0 from "./walletList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./walletList.vue?vue&type=style&index=1&id=6d10c84e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./walletList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10c84e",
  null
  
)

export default component.exports